import nuvamaLogo from "../../assets/images/svg/nuvama_logo.svg";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import BG_small from "../../assets/images/png/BG_small.png";
// import appStore from "../../assets/images/png/appStore.png";
// import playStore from "../../assets/images/png/playStore.png";
// import rightIcon from "../../assets/images/svg/rightIcon.svg";
import {
  LOGIN_TYPE_EMPLOYEE,
  LOGIN_TYPE_LIAISON_OFFICER,
  LOGIN_TYPE_USER,
} from "../../utils/errorConstants";
import UserLogin from "./User";
import LiaisonOfficerLogin from "./LiaisonOfficer";
import EmployeeLogin from "./Employee";
import { useNavigate, useParams } from "react-router";
import { observer } from "mobx-react";
import { useEffect } from "react";
import AuthStore from "../../store/AuthStore";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { getCookie, setCookie } from "../../utils/cookie";
import { useState } from "react";
import { buildDetails, homePageRoute } from "../../utils/constants";
import PageHeading from "../../components/PageHeading/PageHeading";

const Login = observer(() => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { type } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      type !== "family-office-team" &&
      type !== "user" &&
      type !== "employee" &&
      type !== undefined
    ) {
      navigate("/not-found");
    }
  }, [navigate, type]);

  const refresh = () => {
    if (!getCookie("isRefreshed")) {
      window.location.reload(true);
      setCookie("isRefreshed", true);
    }
  };

  useEffect(() => {
    refresh();
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    // On initial load, check the server status if it hasn’t been checked yet.
    // If the server is available, call getPublicKey API and enable login; otherwise, keep login disabled
    // and show the appropriate server-down message.
    if (AuthStore.isServerDown === "default") {
      AuthStore.updateLoadingFullScreen(true);
      AuthStore.getServerMsg({
        onSuccess: ({ data }) => {
          AuthStore.setData("publicKeyData", {
            ...AuthStore.publicKeyData,
            isFetching: true,
          });

          // Call getPublicKey API

          AuthStore.getPublicKey({
            onSuccess: ({ data }) => {
              AuthStore.setData("publicKeyData", {
                isFetching: null,
                fetchStatus: "success",
                publicKey: data.publicKey,
              });
            },
            onFail: ({ error }) => {
              AuthStore.setData("publicKeyData", {
                isFetching: null,
                fetchStatus: "failed",
                publicKey: null,
              });
            },
          });
        },
      });
    }
  }, []);

  const isLoggedIn = getCookie("token");
  useEffect(() => {
    if (isLoggedIn) {
      navigate(`/${homePageRoute}`);
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  if (
    AuthStore.isLoadingFullScreen ||
    AuthStore.publicKeyData.isFetching ||
    !isLoaded
  ) {
    return <LoadingScreen />;
  } else
    return (
      <>
        <div>
          <div className={`curved-separated-page`}>
            <div className="seperater-login-container">
              <div className="login-page-wrapper">
                <div className="login-page-main-wrapper">
                  <img className="back" src={BG_small} />
                  <div className="logo_wrapper">
                    <img className="nuvama_logo logo" src={nuvamaLogo} alt="" />
                  </div>
                </div>
              </div>
              {false && (
                <div className="login-container-new">
                  <div
                    className={
                      AuthStore.isServerDown
                        ? "login_card_container low_padding"
                        : "login_card_container more_padding"
                    }
                  >
                    {AuthStore.isLoadingForLogin && (
                      <div className="login_loader_container">
                        <img
                          className="loader_gif"
                          src={loaderGIF}
                          alt="loading..."
                        />
                      </div>
                    )}
                    <div className="login_components">
                      {(type === LOGIN_TYPE_USER || !type) && <UserLogin />}
                      {type === LOGIN_TYPE_LIAISON_OFFICER && (
                        <LiaisonOfficerLogin />
                      )}
                      {type === LOGIN_TYPE_EMPLOYEE && <EmployeeLogin />}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="other-container">
              <div className="login-container-new">
                <div
                  className={
                    AuthStore.isServerDown
                      ? "login_card_container low_padding"
                      : "login_card_container more_padding"
                  }
                >
                  {AuthStore.isLoadingForLogin && (
                    <div className="login_loader_container">
                      <img
                        className="loader_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  )}
                  <PageHeading
                    headingClass="login-page-heading"
                    headingText="Login"
                  />
                  <div className="login_components">
                    {(type === LOGIN_TYPE_USER || !type) && <UserLogin />}
                    {type === LOGIN_TYPE_LIAISON_OFFICER && (
                      <LiaisonOfficerLogin />
                    )}
                    {type === LOGIN_TYPE_EMPLOYEE && <EmployeeLogin />}
                  </div>
                </div>
              </div>
            </div>

            <div className="login-page-footer">
              <ul className="footer-new">
                <a
                  href={`${process.env.REACT_APP_PRE_LOGIN_URL}/disclaimer/`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Disclaimer </li>
                </a>
                <a
                  href={`${process.env.REACT_APP_PRE_LOGIN_URL}/privacy-policy/`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Privacy Policy </li>
                </a>
                <a
                  href={`${process.env.REACT_APP_PRE_LOGIN_URL}/terms-conditions/`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Terms & Conditions</li>
                </a>
                <a
                  href={`${process.env.REACT_APP_PRE_LOGIN_URL}/contact-us/`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Contact Us</li>
                </a>
              </ul>
            </div>
            <div className="login-build-details">{buildDetails}</div>
          </div>
        </div>
      </>
    );
});

export default Login;
